import React from "react";
import "./Schedule.scss";
import FadeInSection from "./FadeInSection";
import RingsIcon from "./images/rings.webp";

function Schedule({ t }) {
  return (
    <div className="bg-base">
      <div className="timeline p-top-8 p-bottom-8">
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content col-8 text-center">
              <h5 className="m-bottom-1 font-body">{t.scheduleLocationLabel}</h5>
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="font-body font-weight-700 letter-spacing-2px">{t.villaName}</span>
              </h4>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content col-8 text-center">
              <div className="flex flex-align-center gap-1 hearth-separator heart-date"><i className="fa-solid fa-heart text-third text-xs"></i><div className="h5 text-third font-body font-weight-700 font-weight-700">{t.scheduleDate1}</div></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left flex flex-justify-end flex-justify-center-xsm">
            <div className="content col-8 text-center">
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-border font-body font-weight-700 font-weight-700">14:00</span>
              </h4>
              <h5 className="m-bottom-1 font-body">{t.scheduleCheckIn}</h5>
              <i className="fa-solid m-top-1 fa-martini-glass-citrus m-right-1 text-xl text-border" />
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-14"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content col-8 text-center">
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-border font-body font-weight-700">15:30</span>
              </h4>
              <h5 className="m-bottom-1 font-body">{t.scheduleGathering}</h5>
              <i className="fa-solid fa-people-pulling m-top-1 m-right-1 text-xl text-border" />
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-30"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-15"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left flex flex-justify-end">
            <div className="content col-8 text-center">
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-border font-body font-weight-700">17:00</span>
              </h4>
              <h5 className="m-bottom-1 font-body">{t.scheduleCeremony}</h5>
              <img
                alt=""
                src={RingsIcon}
                style={{ width: 30 }}
                className="flex text-xl m-left-auto m-right-auto"
              />
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-17"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content col-8 text-center">

              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-border font-body font-weight-700">19:30</span>
              </h4>
              <h5 className="m-bottom-1 font-body">{t.scheduleDinner}</h5>
              <i className="fa-solid m-top-1 fa-utensils m-right-1 text-xl text-border" />
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-30"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-19"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content col-8 text-center">
              <div className="flex flex-align-center gap-1 hearth-separator heart-date"><i className="fa-solid fa-heart text-third text-xs"></i><div className="h5 text-third font-body font-weight-700 font-weight-700">{t.scheduleDate2}</div></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left flex flex-justify-end flex-justify-center-xsm">
            <div className="content col-8 text-center">
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-border font-body font-weight-700">09:00 - 11:00</span>
              </h4>
              <h5 className="m-bottom-1 font-body">{t.scheduleBreakfast}</h5>
              <i className="m-top-1 fa-solid fa-mug-hot m-right-1 text-xl text-border" />
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-9"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content col-8 text-center">
              <h4 className="flex flex-align-center flex-justify-center m-bottom-1">
                <span className="text-border font-body font-weight-700">12:00</span>
              </h4>
              <h5 className="m-bottom-1 font-body">{t.scheduleCheckout}</h5>
              <i className="m-top-1 fa-solid fa-car-side m-right-1 text-xl text-border" />
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-12"></div>
            </div>
          </div>
        </FadeInSection>
      </div>
    </div>
  );
}

export default Schedule;
